export default "__VITE_ASSET__1cd149d6__"